<template>
    <el-popover v-model="show" trigger="click" width="350">
        <i slot="reference"
           :class="[messageUnreadCount?'message-new':'','message el-icon-bell']"
           @click="getList(currentPage)"></i>
        <div style="padding-bottom: 5px; text-align: right">
            <el-button :disabled="!messageUnreadCount" type="success" plain size="mini" @click="readAllFunc">全部标为已读</el-button>
        </div>
        <div v-loading="loading" class="message-list common-scroll">
            <div v-for="item of messageList.beanList"
                 :key="item.msgId"
                 :class="[item.status?'':'message-new','message-item']" @click="goTo(item.msgId,item.redirectUrl)">
                <p>{{item.message}}</p>
                <p class="message-item-time">{{item.sendingTime}}</p>
            </div>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next"
                background
                :page-size="20"
                :pager-count="5"
                :total="messageList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </el-popover>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'

    export default {
        computed: {
            ...mapState('messages', ['messageUnreadCount', 'messageList'])
        },
        data() {
            return {
                loading: false,
                show: false,
                currentPage: 1,
                interval:null,
            }
        },
        created() {
            this.intervalNews();
            this.interval = setInterval(()=>{
                if(this.messageUnreadCount > 0){
                    document.getElementById('newsAudio').play()
                }
            },1000 * 60 * 1)
        },
        destroyed() {
            clearInterval(this.interval);
            this.interval = null;
            this.setStateNewsInterval({
                info: null,
                clear: true
            })
        },
        methods: {
            ...mapMutations('messages', ['setStateNewsInterval']),
            ...mapActions('messages', ['intervalNews', 'getMessageList', 'readMessage','readAllMessage']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getMessageList(page).then(() => {
                    this.loading = false;
                })
            },
            readAllFunc(){
              this.readAllMessage().then(()=>{
                  this.getList(this.currentPage)
              })
            },
            goTo(msgId, url) {
                this.readMessage(msgId).then(() => {
                    this.show = false;
                    this.$router.push({
                        path: url
                    })
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .message {
        position: relative;
        margin-right: 100px;
        font-size: 22px;
        cursor: pointer;
        &:hover {
            color: $color-black1;
            transform: translateY(1px);
        }
        &-new::after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: red;
        }
        &-list {
            height: 50vh;
            max-height: 500px;
            margin-bottom: -15px;
            border-top: 1px solid $theme-color;
            border-bottom: 1px solid $theme-color;
        }
        &-item {
            position: relative;
            padding: 10px 15px;
            font-size: 16px;
            border-bottom: 1px solid $border-color;
            cursor: pointer;
            &:hover {
                background-color: rgba($theme-color, 0.1);
            }
            &.message-new::after {
                top: 16px;
                left: 0;
            }
            &-time {
                padding-top: 10px;
                font-size: 14px;
                text-align: right;
            }
        }
    }
</style>